<template>
    <Card :header="$t('filters')">

        <form @keyup.enter="parentComponent.filterData()">

            <b-form-group :label="$t('gtin')" label-cols-sm="3">
                <b-form-input v-model="parentComponent.filters.gtins[0]" :disabled="loading" />
            </b-form-group>

            <b-form-group :label="$t('code')" label-cols-sm="3">
                <b-form-input v-model="parentComponent.filters.code" :disabled="loading" />
            </b-form-group>

            <b-form-group :label="$t('product')" label-cols-sm="3">
                <Multiselect
                    :track-by-label="$t('id')"
                    :initial-value="parentComponent.filtersParams.product"
                    :fetch-options-function="fetchProducts"
                    :placeholder="$t('selectField.placeholder')"
                    asynchronous
                    show-selected
                    track-by="id"
                    label="name"
                    :disabled="loading"
                    @changeTrackBy="parentComponent.filters.product = $event"
                />
            </b-form-group>

            <b-form-group :label="$t('manufacturer')" label-cols-sm="3">
                <Multiselect
                    :initial-value="parentComponent.filtersParams.manufacturer"
                    :fetch-options-function="fetchManufacturers"
                    :asynchronous="false"
                    track-by="id"
                    label="name"
                    :disabled="loading"
                    @changeTrackBy="parentComponent.filters.manufacturer = $event"
                />
            </b-form-group>

            <b-form-group :label="$t('url')" label-cols-sm="3">
                <b-form-input v-model="parentComponent.filters.url" :disabled="loading" />
            </b-form-group>

            <b-form-group :label="$t('description')" label-cols-sm="3">
                <b-form-input v-model="parentComponent.filters.description" :disabled="loading" />
            </b-form-group>

            <div class="d-flex gap-3">
                <ButtonIcon :disabled="loading" @click="parentComponent.filterData()">
                    {{ $t('filter') }}
                </ButtonIcon>
                <ButtonIcon variant="light" :disabled="loading" @click="parentComponent.resetData()">
                    {{ $t('reset') }}
                </ButtonIcon>
            </div>

        </form>
    </Card>
</template>



<script>
    import Multiselect from '@/components/common/Multiselect.vue';

    export default {
        name: 'Filters',
        components: {
            Multiselect,
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        data() {
            return {
                requestProducts: this.$req('catalog/products'),
                requestManufacturers: this.$req('catalog/manufacturers'),
            };
        },
        computed: {
            loading() {
                return this.parentComponent.loading;
            },
        },
        methods: {
            fetchProducts({ search }) {
                const requestParams = {
                    sort: 'name',
                    order: 'ASC',
                    page: 1,
                    perPage: Number.MAX_SAFE_INTEGER,
                    name: search,
                };
                return this.requestProducts.get({ requestParams }).then(data => data?.items || []);
            },
            fetchManufacturers() {
                const requestParams = {
                    sort: 'name',
                    order: 'ASC',
                    page: 1,
                    perPage: Number.MAX_SAFE_INTEGER,
                };
                return this.requestManufacturers
                    .get({ requestParams })
                    .then(data => data.items || [])
                    .catch(() => {});
            },
        },
    };
</script>
